import React from 'react';
import VerificationForm from './components/VerificationForm';
import './App.css';

function App() {
  return (
    <div className="App">
      <VerificationForm />
    </div>
  );
}

export default App;
